import apiClient from '@/services/AccountClient'

export default {
  fetchAll (params) {
    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/channels/routes',
      params
    )
  },
  fetch (id) {
    return apiClient.sendRequest(
      'GET',
      `api/admin/v1/channels/routes/${id}`
    )
  },
  create (data) {
    return apiClient.sendRequest(
      'POST',
      'api/admin/v1/channels/routes/new',
      data
    )
  },
  updateAll (data) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/channels/routes`,
      data
    )
  },
  update (id, data) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/channels/routes/${id}`,
      data
    )
  },
  delete (id) {
    return apiClient.sendRequest(
      'DELETE',
      `api/admin/v1/channels/routes/${id}`,
      undefined
    )
  }
}
